// scroll-image-text.liquid
class ScrollingImageText extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.textBlocks = [];
    this.images = [];
    this.currentIndex = 0;
    this.onScroll = this.onScroll.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    if (window.matchMedia('(max-width: 768px)').matches) return;

    this.textBlocks = Array.from(
      this.querySelectorAll('.sit-text-block')
    );
    this.images = Array.from(
      this.querySelectorAll('.sit-image')
    );

    if (!this.textBlocks.length || !this.images.length) return;

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.onScroll(); // initial sync
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
    this._initialized = false;
  }

  onScroll() {
    const viewportCenter = window.innerHeight * 0.45;

    let closestIndex = 0;
    let closestDistance = Infinity;

    this.textBlocks.forEach((block, index) => {
      const rect = block.getBoundingClientRect();
      const blockCenter = rect.top + rect.height / 2;
      const distance = Math.abs(blockCenter - viewportCenter);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    if (closestIndex !== this.currentIndex) {
      this.currentIndex = closestIndex;
      this.activateImage(closestIndex);
    }
  }

  activateImage(index) {
    this.images.forEach(img => {
      img.classList.toggle(
        'is-active',
        Number(img.dataset.index) === index
      );
    });
  }
}

customElements.define(
  'scrolling-image-text',
  ScrollingImageText
);

document.addEventListener('shopify:section:load', e => {
  e.target
    .querySelectorAll('scrolling-image-text')
    .forEach(el => el.connectedCallback());
});

document.addEventListener('shopify:section:unload', e => {
  e.target
    .querySelectorAll('scrolling-image-text')
    .forEach(el => el.disconnectedCallback());
});


// product page tabs-block.liquid
class ProductInfoTabs extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.buttons = this.querySelectorAll('.tab-btn');
    this.panels = this.querySelectorAll('.tab-panel');

    if (!this.buttons.length || !this.panels.length) return;

    this.ensureInitialActive();

    this.addEventListener('click', (e) => {
      const btn = e.target.closest('.tab-btn');
      if (!btn || !this.contains(btn)) return;

      e.preventDefault();
      this.activate(btn.dataset.tab);
    });
  }

  ensureInitialActive() {
    const activeBtn = this.querySelector('.tab-btn.is-active');
    if (activeBtn) {
      this.activate(activeBtn.dataset.tab);
      return;
    }

    // 첫 버튼 자동 활성화
    const firstBtn = this.buttons[0];
    if (firstBtn) {
      firstBtn.classList.add('is-active');
      this.activate(firstBtn.dataset.tab);
    }
  }

  activate(tabKey) {
    if (!tabKey) return;

    this.buttons.forEach((btn) => {
      const isActive = btn.dataset.tab === tabKey;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    this.panels.forEach((panel) => {
      panel.classList.toggle(
        'is-active',
        panel.dataset.panel === tabKey
      );
    });
  }
}

if (!customElements.get('product-info-tabs')) {
  customElements.define('product-info-tabs', ProductInfoTabs);
}
